import React from "react";
import {
  Highlight,
  HighlightLabel,
  HighlightsCard,
  HighlightsSection,
  HighlightValue,
} from "./HomeHighlightsElements";
import { useLanguage } from "../../../contexts";
import { HOME_CONTENT_ID } from "../HomeHeader/HomeHeader";

const HIGHLIGHTS = [
  { value: "5", labelKey: "HOME.HIGHLIGHTS.GENERATIONS" },
  { value: "~400", labelKey: "HOME.HIGHLIGHTS.COLONIES" },
  // Nektária honey competition results 2022–2026, listed on the About page.
  // Update together with ABOUT.SECTIONS.SECTION4 when new results are added.
  { value: "18", labelKey: "HOME.HIGHLIGHTS.AWARDS" },
];

const HomeHighlights = () => {
  const { t } = useLanguage();

  return (
    <HighlightsSection>
      <HighlightsCard id={HOME_CONTENT_ID}>
        {HIGHLIGHTS.map((highlight, index) => (
          <Highlight key={highlight.labelKey} $index={index}>
            <HighlightValue>{highlight.value}</HighlightValue>
            <HighlightLabel>{t(highlight.labelKey)}</HighlightLabel>
          </Highlight>
        ))}
      </HighlightsCard>
    </HighlightsSection>
  );
};

export default HomeHighlights;
